import Service, { service } from '@ember/service';
import { all, task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';

export default class LogRepoService extends Service {
  @service eflexAjax;
  @service store;
  @service currentUser;

  logs = this.store.peekAll('log');

  acknowledgeLogs = task(waitFor(async logs => {
    logs.forEach(log => { log.acknowledge(); });
    await all(logs.map(log => log.save()));
  }));

  acknowledgeAll = task(waitFor(async () => {
    await this.eflexAjax.post.linked().perform('logs/acknowledgeAll', {});
  }));

  deployBySource = task(waitFor(async source => {
    await this.eflexAjax.post.linked().perform('logs/deploy', { source });
  }));
}
